import { NgComponentOutlet } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { INoData } from '../shared.model';
import { ActionGroup } from '../action-group/action-group';

@Component({
  selector: 'pf-no-data-box',
  templateUrl: './no-data-box.component.html',
  styleUrls: ['./no-data-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ActionGroup, NgComponentOutlet]
})
export class NoDataBoxComponent {
  public readonly data = input<INoData>(null);
}
